export default __webpack_public_path__ + "static/media/warning-icon.e03cc51c.png";